import type { IconSvgObject } from './types';

const BitcoinSearchIcon: IconSvgObject = [
  ["path", { d: "M17.5 17.5L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.5 8H9.5M12 11H9.5M12 11C12.8284 11 13.5 10.3284 13.5 9.5C13.5 8.67157 12.8284 8 12 8H11M12 11C12.8284 11 13.5 11.6716 13.5 12.5C13.5 13.3284 12.8284 14 12 14H11M9.5 11V8M9.5 11V14M8.5 14H9.5M9.5 8H11M9.5 14H11M11 8V7M11 14V15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BitcoinSearchIcon;
